var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.params.text)}})]),_c('p',{staticClass:"dialog-footer tac mt20"},[_c('el-button',{staticClass:"action-btn ml20",attrs:{"type":"primary","loading":_vm.formLoading},on:{"click":_vm.submitModal}},[_vm._v("已知晓")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }